(function ($) {
    'use strict';

    var i18n = (ThemeJS.Variables.Lists && ThemeJS.Variables.Lists.i18n) || {};
    var LAST_LIST_STORAGE_KEY = 'flutterbee_last_add_to_list_id';

    function getAddModal() {
        return document.getElementById('my-lists-add-modal');
    }

    function getBulkAddModal() {
        return document.getElementById('my-lists-bulk-add-modal');
    }

    function getStoredListId() {
        try {
            return window.localStorage.getItem(LAST_LIST_STORAGE_KEY) || '';
        } catch (e) {
            return '';
        }
    }

    function storeListId(listId) {
        listId = listId ? String(listId) : '';
        if (!listId) {
            return;
        }

        try {
            window.localStorage.setItem(LAST_LIST_STORAGE_KEY, listId);
        } catch (e) {
            // Ignore storage failures (private mode, quota, etc.).
        }
    }

    function getAddForm() {
        var modalEl = getAddModal();
        return modalEl ? $(modalEl).find('[data-my-lists-add-form]') : $();
    }

    function setModalProductId(productId) {
        var $form = getAddForm();
        if (!$form.length) {
            return;
        }

        $form.data('product-id', productId).attr('data-product-id', productId);
        $form.data('requires-variation', false).attr('data-requires-variation', '0');
    }

    function resetVariationSelect() {
        var $form = getAddForm();
        var $wrap = $form.find('[data-my-lists-variation-wrap]');
        var $select = $form.find('[data-my-lists-variation-select]');

        $wrap.prop('hidden', true);
        $select.prop('disabled', false).empty().append(
            $('<option>', {
                value: '',
                text: i18n.select_isbn || 'Select an ISBN',
            })
        );
    }

    function getSelectedVariationIdFromPage() {
        var $variationInput = $('form.variations_form input[name="variation_id"]');
        if (!$variationInput.length) {
            return 0;
        }

        return parseInt($variationInput.val(), 10) || 0;
    }

    function loadVariations(productId) {
        var $form = getAddForm();
        var $wrap = $form.find('[data-my-lists-variation-wrap]');
        var $select = $form.find('[data-my-lists-variation-select]');
        var deferred = $.Deferred();

        resetVariationSelect();

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_get_variations',
                product_id: productId,
            },
            success: function (data) {
                var variations = data.variations || [];
                var requiresVariation = !!data.requires_variation;
                var defaultVariationId = parseInt(data.default_variation_id, 10) || 0;

                $form.data('requires-variation', requiresVariation).attr('data-requires-variation', requiresVariation ? '1' : '0');

                if (!requiresVariation || !variations.length) {
                    deferred.resolve();
                    return;
                }

                $wrap.prop('hidden', false);
                $select.empty().append(
                    $('<option>', {
                        value: '',
                        text: i18n.select_isbn || 'Select an ISBN',
                    })
                );

                variations.forEach(function (variation) {
                    $select.append(
                        $('<option>', {
                            value: String(variation.id),
                            text: variation.label || variation.isbn || variation.id,
                        })
                    );
                });

                var selectedVariationId = getSelectedVariationIdFromPage();
                if (defaultVariationId && $select.find('option[value="' + defaultVariationId + '"]').length) {
                    $select.val(String(defaultVariationId));
                } else if (selectedVariationId && $select.find('option[value="' + selectedVariationId + '"]').length) {
                    $select.val(String(selectedVariationId));
                } else if (variations.length === 1) {
                    $select.val(String(variations[0].id));
                }

                deferred.resolve();
            },
            error: function () {
                deferred.reject();
            },
        });

        return deferred.promise();
    }

    function openAddModal(productId) {
        var modalEl = getAddModal();
        if (!modalEl || typeof bootstrap === 'undefined') {
            return;
        }

        if (modalEl.parentElement !== document.body) {
            document.body.appendChild(modalEl);
        }

        setModalProductId(productId);
        resetVariationSelect();
        resetFormSelection(getAddForm());

        var modal = bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();

        var $submit = getAddForm().find('[data-my-lists-submit]');
        setSubmitLoading($submit, true, i18n.loading_variations || 'Loading formats...');

        loadVariations(productId).always(function () {
            setSubmitLoading($submit, false);
        });
    }

    function setSubmitLoading($button, isLoading, label) {
        var $submitLabel = $button.find('.my-lists-submit-label');
        var $spinner = $button.find('.my-lists-submit-spinner');

        if (isLoading) {
            $button.prop('disabled', true);
            $button.data('original-label', $submitLabel.text());
            $submitLabel.text(label);
            $spinner.prop('hidden', false);
        } else {
            $button.prop('disabled', false);
            if ($button.data('original-label')) {
                $submitLabel.text($button.data('original-label'));
            }
            $spinner.prop('hidden', true);
        }
    }

    function escapeHtml(text) {
        return $('<div>').text(text).html();
    }

    function clearFormFeedback($form) {
        $form.find('[data-my-lists-form-feedback]').empty().prop('hidden', true).removeClass('is-error');
        clearFormSuccesses($form);
    }

    function clearFormSuccesses($form) {
        $form.find('[data-my-lists-form-successes]').empty().prop('hidden', true);
    }

    function getFormSuccesses($form) {
        var $successes = $form.find('[data-my-lists-form-successes]');

        if (!$successes.length) {
            $successes = $('<div class="my-lists-form-successes" data-my-lists-form-successes hidden></div>');
            $form.find('[data-my-lists-submit]').after($successes);
        }

        return $successes;
    }

    function clearFormErrors($form) {
        var $feedback = $form.find('[data-my-lists-form-feedback]');

        $feedback.find('.is-error').remove();

        if (!$feedback.children().length) {
            $feedback.prop('hidden', true).removeClass('is-error');
            return;
        }

        if (!$feedback.find('.is-error').length) {
            $feedback.removeClass('is-error');
        }
    }

    function appendFormSuccess($form, data) {
        var feedback = buildSuccessMessage(data);
        var $successes = getFormSuccesses($form);
        var $item = $('<div class="my-lists-add-feedback__item" />');

        if (feedback.isHtml) {
            $item.html(feedback.html);
        } else {
            $item.text(feedback.html);
        }

        $successes.append($item).prop('hidden', false);
    }

    function appendFormError($form, message) {
        var $feedback = $form.find('[data-my-lists-form-feedback]');

        $feedback.append($('<div class="my-lists-add-feedback__item is-error" />').text(message));
        $feedback.prop('hidden', false).addClass('is-error');
    }

    function getServerDefaultListId($form) {
        var defaultListId = $form.data('default-list-id') || $form.attr('data-default-list-id') || '';

        return defaultListId ? String(defaultListId) : '';
    }

    function getDefaultListId($form) {
        var $select = $form.find('[data-my-lists-select]');
        var storedListId = getStoredListId();

        if (storedListId && $select.find('option[value="' + storedListId + '"]').length) {
            return storedListId;
        }

        var serverDefaultListId = getServerDefaultListId($form);

        return serverDefaultListId && $select.find('option[value="' + serverDefaultListId + '"]').length
            ? serverDefaultListId
            : '';
    }

    function setDefaultListId($form, listId) {
        listId = listId ? String(listId) : '';
        $form.data('default-list-id', listId).attr('data-default-list-id', listId);
        $form.find('[data-my-lists-select]').data('default-list-id', listId).attr('data-default-list-id', listId);
    }

    function resetFormSelection($form) {
        var $select = $form.find('[data-my-lists-select]');
        var defaultListId = getDefaultListId($form);

        $select.val(defaultListId || '');
        $form.find('[data-my-lists-new-title-wrap]').prop('hidden', true);
        $form.find('[data-my-lists-new-title]').val('');
    }

    function addListOption($form, list) {
        if (!list || !list.id) {
            return;
        }

        var $select = $form.find('[data-my-lists-select]');
        var listId = String(list.id);

        if ($select.find('option[value="' + listId + '"]').length) {
            return;
        }

        $('<option>', {
            value: listId,
            text: list.title || listId,
        }).insertBefore($select.find('option[value="__new__"]'));
    }

    function buildSuccessMessage(data) {
        var list = data.list || {};
        var listTitle = list.title || '';
        var message = data.message || '';

        if (!message && listTitle) {
            message = (i18n.added_to_list || 'Successfully added to list: %s').replace('%s', listTitle);
        }

        if (!data.list_url || !listTitle || message.indexOf(listTitle) === -1) {
            return { html: message, isHtml: false };
        }

        var linkedTitle = '<a href="' + escapeHtml(data.list_url) + '">' + escapeHtml(listTitle) + '</a>';

        return {
            html: message.replace(listTitle, linkedTitle),
            isHtml: true,
        };
    }

    $(function () {
        var modalEl = getAddModal();
        if (modalEl && modalEl.parentElement !== document.body) {
            document.body.appendChild(modalEl);
        }
    });

    $(document).on('click', '[data-my-lists-open-modal]', function (event) {
        event.preventDefault();

        var $trigger = $(this);
        var productId = $trigger.data('product-id') || $trigger.closest('[data-my-lists-add]').data('product-id') || 0;
        openAddModal(productId);
    });

    $(document).on('change', '[data-my-lists-select]', function () {
        var isNew = $(this).val() === '__new__';
        $(this).closest('form').find('[data-my-lists-new-title-wrap]').prop('hidden', !isNew);
    });

    $(document).on('hidden.bs.modal', '#my-lists-add-modal', function () {
        var $form = $(this).find('[data-my-lists-add-form]');
        $form[0].reset();
        resetFormSelection($form);
        resetVariationSelect();
        clearFormFeedback($form);
        setSubmitLoading($form.find('[data-my-lists-submit]'), false);
    });

    function getBulkAddForm() {
        var modalEl = getBulkAddModal();
        return modalEl ? $(modalEl).find('[data-my-lists-bulk-add-form]') : $();
    }

    function openBulkAddModal(items, format) {
        var modalEl = getBulkAddModal();
        if (!modalEl || typeof bootstrap === 'undefined') {
            return;
        }

        if (modalEl.parentElement !== document.body) {
            document.body.appendChild(modalEl);
        }

        var $form = getBulkAddForm();
        $form.data('items', items || []).attr('data-items-json', JSON.stringify(items || [])).attr('data-format', format || '');
        resetFormSelection($form);
        clearFormFeedback($form);

        bootstrap.Modal.getOrCreateInstance(modalEl).show();
    }

    $(function () {
        var bulkModalEl = getBulkAddModal();
        if (bulkModalEl && bulkModalEl.parentElement !== document.body) {
            document.body.appendChild(bulkModalEl);
        }
    });

    $(document).on('flutterbee:open-bulk-list-modal', function (event, items, format) {
        openBulkAddModal(items || [], format || '');
    });

    $(document).on('hidden.bs.modal', '#my-lists-bulk-add-modal', function () {
        var $form = $(this).find('[data-my-lists-bulk-add-form]');
        if ($form[0]) {
            $form[0].reset();
        }
        resetFormSelection($form);
        clearFormFeedback($form);
        setSubmitLoading($form.find('[data-my-lists-submit]'), false);
    });

    $(document).on('submit', '[data-my-lists-bulk-add-form]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $button = $form.find('[data-my-lists-submit]');
        var selected = $form.find('[data-my-lists-select]').val();
        var items = $form.data('items') || [];
        if (!items || !items.length) {
            try {
                items = JSON.parse($form.attr('data-items-json') || '[]');
            } catch (e) {
                items = [];
            }
        }

        clearFormErrors($form);

        if (!items.length) {
            appendFormError($form, 'Choose a product first.');
            return;
        }

        var payload = {
            action: 'lists_add_items',
            items: JSON.stringify(items),
            format: $form.attr('data-format') || '',
        };

        if (selected === '__new__') {
            payload.title = $form.find('[data-my-lists-new-title]').val();
            setSubmitLoading($button, true, i18n.creating || 'Creating...');
        } else if (selected) {
            payload.list_id = selected;
            setSubmitLoading($button, true, i18n.adding || 'Adding...');
        } else {
            appendFormError($form, 'Select or create a list.');
            return;
        }

        ThemeJS.Functions.send_ajax_request({
            data: payload,
            success: function (data) {
                var list = data.list || {};
                var listId = list.id ? String(list.id) : (selected !== '__new__' ? String(selected) : '');

                addListOption($form, list);
                if (getAddForm().length) {
                    addListOption(getAddForm(), list);
                    if (listId) {
                        setDefaultListId(getAddForm(), listId);
                    }
                }

                if (listId) {
                    storeListId(listId);
                    setDefaultListId($form, listId);
                    setDefaultListId(getAddForm(), listId);
                }

                if (selected === '__new__' && listId) {
                    $form.find('[data-my-lists-select]').val(listId);
                    $form.find('[data-my-lists-new-title-wrap]').prop('hidden', true);
                    $form.find('[data-my-lists-new-title]').val('');
                }

                appendFormSuccess($form, data);
                $(document).trigger('flutterbee:bulk-list-add-success');
                setSubmitLoading($button, false);
            },
            error: function (data) {
                appendFormError($form, data.message || 'Error');
                setSubmitLoading($button, false);
            },
        });
    });

    $(document).on('hidden.bs.modal', '#my-lists-cart-modal', function () {
        var $form = $(this).find('[data-my-lists-cart-form]');
        $form[0].reset();
        resetFormSelection($form);
        clearFormFeedback($form);
        setSubmitLoading($form.find('[data-my-lists-submit]'), false);
    });

    $(document).on('submit', '[data-my-lists-cart-form]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $button = $form.find('[data-my-lists-submit]');
        var selected = $form.find('[data-my-lists-select]').val();
        var payload = { action: 'lists_add_cart' };

        clearFormErrors($form);

        if (selected === '__new__') {
            payload.title = $form.find('[data-my-lists-new-title]').val();
            setSubmitLoading($button, true, i18n.creating || 'Creating...');
        } else if (selected) {
            payload.list_id = selected;
            setSubmitLoading($button, true, i18n.adding || 'Adding...');
        } else {
            appendFormError($form, 'Select or create a list.');
            return;
        }

        ThemeJS.Functions.send_ajax_request({
            data: payload,
            success: function (data) {
                var list = data.list || {};
                var listId = list.id ? String(list.id) : (selected !== '__new__' ? String(selected) : '');

                addListOption($form, list);

                if (listId) {
                    storeListId(listId);
                    setDefaultListId($form, listId);
                }

                if (selected === '__new__' && listId) {
                    $form.find('[data-my-lists-select]').val(listId);
                    $form.find('[data-my-lists-new-title-wrap]').prop('hidden', true);
                    $form.find('[data-my-lists-new-title]').val('');
                }

                appendFormSuccess($form, data);
                setSubmitLoading($button, false);
            },
            error: function (data) {
                appendFormError($form, data.message || 'Error');
                setSubmitLoading($button, false);
            },
        });
    });

    $(document).on('submit', '[data-my-lists-add-form]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $button = $form.find('[data-my-lists-submit]');
        var productId = $form.data('product-id');
        var selected = $form.find('[data-my-lists-select]').val();
        var requiresVariation = String($form.data('requires-variation')) === '1' || String($form.attr('data-requires-variation')) === '1';
        var variationId = $form.find('[data-my-lists-variation-select]').val() || '';

        clearFormErrors($form);
        var payload = {
            action: 'lists_add_item',
            product_id: productId,
        };

        if (!productId) {
            appendFormError($form, 'Choose a product first.');
            return;
        }

        if (requiresVariation && !variationId) {
            appendFormError($form, i18n.select_isbn || 'Select an ISBN.');
            return;
        }

        if (variationId) {
            payload.variation_id = variationId;
        }

        var pageQuantity = parseInt($('form.cart input.qty').first().val(), 10);
        if (pageQuantity > 0) {
            payload.quantity = pageQuantity;
        }

        if (selected === '__new__') {
            payload.title = $form.find('[data-my-lists-new-title]').val();
            setSubmitLoading($button, true, i18n.creating || 'Creating...');
        } else if (selected) {
            payload.list_id = selected;
            setSubmitLoading($button, true, i18n.adding || 'Adding...');
        } else {
            appendFormError($form, 'Select or create a list.');
            return;
        }

        ThemeJS.Functions.send_ajax_request({
            data: payload,
            success: function (data) {
                var list = data.list || {};
                var listId = list.id ? String(list.id) : (selected !== '__new__' ? String(selected) : '');

                addListOption($form, list);

                if (listId) {
                    storeListId(listId);
                    setDefaultListId($form, listId);
                }

                // Keep the user's selection; if they just created a list, switch to it.
                if (selected === '__new__' && listId) {
                    $form.find('[data-my-lists-select]').val(listId);
                    $form.find('[data-my-lists-new-title-wrap]').prop('hidden', true);
                    $form.find('[data-my-lists-new-title]').val('');
                }

                appendFormSuccess($form, data);
                setSubmitLoading($button, false);
            },
            error: function (data) {
                appendFormError($form, data.message || 'Error');
                setSubmitLoading($button, false);
            },
        });
    });
})(jQuery);
